import React, { type FC } from 'react';

import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import moment from 'moment';
import type { AssociateProfileRestriction } from 'src/services/associateProfile/types';

import EmDash from '../emdash';

interface RestrictionHeaderProps {
  restriction: AssociateProfileRestriction;
}

const RestrictionHeader: FC<RestrictionHeaderProps> = ({ restriction }) => (
  <>
    <Row>{restriction.taskName}</Row>
    <Row spacing="300">
      <Link type="secondary" href={`/placementDetails/${restriction.accommodationId}`}>
        {restriction.accommodationType} | {restriction.externalCaseId ?? <EmDash />}
      </Link>
      <Text color="secondary">•</Text>
      <Text color="secondary">Last Updated: {moment(restriction.updatedAt).format('MM/DD/YYYY [at] h:mma')} UTC</Text>
      <Text color="secondary">•</Text>
      <Link
        href={`https://phonetool.amazon.com/users/${restriction.updatedBy}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {restriction.updatedBy}@
      </Link>
    </Row>
  </>
);

export default RestrictionHeader;
